
import { defineComponent, onMounted, ref, Ref } from "vue";
import { JobsAPI } from "@/services/jobs";
import ModalJobMembers from "@/components/modalJobMember/index.vue";
import Avatar from "@/components/avatar/index.vue";
import { createToastAxelerate } from "@/utils/toast";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "JobMemberSection",
  components: {
    ModalJobMembers,
    Avatar,
  },
  props: {
    jobId: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const openModal = ref(false);
    const members: Ref<any> = ref([]);
    const route = useRoute();

    function showModal() {
      openModal.value = true;
    }

    function getMembers() {
      JobsAPI.getJobMembers(String(route.params.id))
        .then((res: any) => {
          members.value = res.data.job.job_members;
        })
        .catch((err: any) => {
          const {
            response: {
              data: { errors },
            },
          } = err;
          createToastAxelerate("Get job members", errors[0], "danger");
        });
    }

    onMounted(() => {
      getMembers();
    });

    return {
      members,
      showModal,
      openModal,
      getMembers,
    };
  },
});
